import { useCallback, useState } from 'react';
import { readPersistedPersona, writePersistedPersona } from './personaStorage.js';
import type { FederatedPersona, PersonaOption } from './types.js';

export const FEDERATED_PERSONA_OPTIONS: ReadonlyArray<PersonaOption> = [
  { value: 'staff', label: 'Staff' },
  { value: 'administrator', label: 'Administrator' },
  { value: 'parent', label: 'Parent' },
];

export type UseFederatedPersonaResult = {
  persona: FederatedPersona | '';
  setPersona: (nextPersona: FederatedPersona | '') => void;
};

export const useFederatedPersona = (
  keys?: ReadonlyArray<string>
): UseFederatedPersonaResult => {
  const [persona, setPersonaState] = useState<FederatedPersona | ''>(() =>
    readPersistedPersona(keys)
  );

  const setPersona = useCallback(
    (nextPersona: FederatedPersona | '') => {
      setPersonaState(nextPersona);
      writePersistedPersona(nextPersona, keys);
    },
    [keys]
  );

  return {
    persona,
    setPersona,
  };
};
